export default "__VITE_ASSET__CeeT9L0C__"